document.addEventListener('variant:change', function (event) {
  const variant = event.detail.variant;
  const currency = Shopify.currency.active || window.Shopify.currency.active || 'USD';
  const countryCode = Shopify.country || 'US'; // 'GB' for United Kingdom

  const formatPrice = (amount) => {
    const value = amount / 100;
    let locale = window.Shopify.locale + '-' + window.Shopify.country; // fallback
    let currencySymbol = '$';
    let showDecimals = false;

    switch (currency) {
      case 'GBP':
        locale = 'en-GB';
        currencySymbol = '£';
        showDecimals = true;
        break;
      case 'AUD':
        locale = 'en-AU';
        currencySymbol = 'A$';
        showDecimals = true;
        break;
      case 'NZD':
        locale = 'en-NZ';
        currencySymbol = 'NZ$';
        showDecimals = true;
        break;
      case 'CAD':
        locale = 'en-CA';
        currencySymbol = 'CA$';
        showDecimals = true;
        break;
      case 'EUR':
        locale = 'de-DE'; // German-style formatting: 12.000,00
        currencySymbol = '€';
        showDecimals = true;
        break;
      case 'USD':
        locale = 'en-US';
        currencySymbol = '$';
        showDecimals = false;
        break;
      default:
        locale = window.Shopify.locale + '-' + window.Shopify.country;
        currencySymbol = '';
        break;
    }
  
    const numberOptions = {
      minimumFractionDigits: showDecimals ? 2 : 0,
      maximumFractionDigits: showDecimals ? 2 : 0,
    };
  
    
    let formattedValue = new Intl.NumberFormat(locale, numberOptions).format(value);
    
    if(currencySymbol != '') {
      return `${currencySymbol}${formattedValue}`;
    } else {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
      }).format(value);
    }
  };
  
  const salePrice = formatPrice(variant.price);
  const compareAtPrice = variant.compare_at_price ? formatPrice(variant.compare_at_price) : '';

  // Update <sale-price>
  document.querySelectorAll('sale-price').forEach(el => {
    Array.from(el.childNodes).forEach(node => {
      if (
        node.nodeType === Node.TEXT_NODE ||
        (node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('sr-only'))
      ) {
        el.removeChild(node);
      }
    });

    el.appendChild(document.createTextNode(salePrice));
  });

  // Update <compare-at-price>
  document.querySelectorAll('compare-at-price').forEach(el => {
    Array.from(el.childNodes).forEach(node => {
      if (
        node.nodeType === Node.TEXT_NODE ||
        (node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('sr-only'))
      ) {
        el.removeChild(node);
      }
    });

    if (compareAtPrice) {
      el.appendChild(document.createTextNode(compareAtPrice));
      el.style.display = '';
    } else {
      el.style.display = 'none';
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const lockScrollDuringClick = () => {
    const scrollX = window.scrollX;
    const scrollY = window.scrollY;
  
    const preventScroll = () => {
      window.scrollTo(scrollX, scrollY);
    };
  
    // Listen immediately to override any scroll attempt
    window.addEventListener('scroll', preventScroll);
  
    // Unlock after a short period
    setTimeout(() => {
      window.removeEventListener('scroll', preventScroll);
    }, 300); // Adjust if needed
  };
  
  document.querySelectorAll('.variant-picker__option-values label').forEach((label) => {
    label.addEventListener('click', (e) => {
      lockScrollDuringClick();
      // const previousScroll = window.scrollY;
      // setTimeout(() => window.scrollTo({ top: previousScroll }), 0);
    });
  });

  if($('.shopify-payment-button')) {
    if(JSON.parse($('.shopify-payment-button shopify-accelerated-checkout').attr('recommended')).name == 'shop_pay') {
      $('.shopify-payment-button').addClass('shopify-payment-button-shop_pay');
    } else if (JSON.parse($('.shopify-payment-button shopify-accelerated-checkout').attr('recommended')).name == 'paypal') {
      $('.shopify-payment-button').addClass('shopify-payment-button-paypal');
    }
  }


  // Measurement selector
  const inchBtn = document.querySelector("#inch-btn");
  const cmBtn = document.querySelector("#cm-btn");

  // Store original text as data attributes
  inchBtn.dataset.originalText = inchBtn.innerText;
  cmBtn.dataset.originalText = cmBtn.innerText;

  // Function to detect if the user is in the US
  const isUserInUS = () => {
    const locale = Intl.DateTimeFormat().resolvedOptions().locale;
    return locale.startsWith("en-US");
  };

  const userInUS = isUserInUS();
  let currentMeasurement = userInUS ? 0 : 1;

  inchBtn.addEventListener("click", function () {
    cmBtn.classList.remove("measurement-btn--active");
    inchBtn.classList.add("measurement-btn--active");
    currentMeasurement = 0;
    handleMeasurementChange(currentMeasurement); // Pass 0 for inch
  });

  cmBtn.addEventListener("click", function () {
    inchBtn.classList.remove("measurement-btn--active");
    cmBtn.classList.add("measurement-btn--active");
    currentMeasurement = 1;
    handleMeasurementChange(1); // Pass 1 for cm
  });

  const collectSizeButtons = function() {
    let sizeButtons = [];
    // Find size buttons in block format (old format)
    const variantsButtons = document.querySelectorAll(".variant");
    variantsButtons.forEach((item) => {
      if (item.getAttribute("data").includes("/")) {
        sizeButtons.push(item);
      }
    });
    // Find size buttons in dropdown format (new format)
    const dropdownPopovers = document.querySelectorAll(".popover--size-dropdown");
    dropdownPopovers.forEach((popover) => {
      // Find all dropdown option buttons
      const dropdownButtons = popover.querySelectorAll("button[role='option']");
      dropdownButtons.forEach((button) => {
        const value = button.getAttribute("value");
        if (value && value.includes("/")) {
          sizeButtons.push(button);
        }
      });
      // Find the selected value display (the button that opens the dropdown)
      const popoverId = popover.getAttribute("id");
      if (popoverId) {
        const selectButton = document.querySelector(`.select[aria-controls="${popoverId}"]`);
        if (selectButton) {
          const selectedValueSpan = selectButton.querySelector(`#${popoverId}-selected-value`);
          if (selectedValueSpan) {
            // Get the current value from the hidden input
            const hiddenInput = popover.querySelector("input[type='hidden']");
            if (hiddenInput && hiddenInput.value.includes("/")) {
              sizeButtons.push(selectedValueSpan);
            }
          }
        }
      }
    });
    return sizeButtons;
  };

  const handleMeasurementChange = function (measurement) {
    const sizeButtons = collectSizeButtons();
    sizeButtons.forEach((button) => {
      // Get the full value from either 'data' attribute (block format) or 'value' attribute (dropdown format)
      let data = button.getAttribute("data");
      if (!data) {
        // For dropdown buttons, check the value attribute
        data = button.getAttribute("value");
      }
      // For selected value span, get from hidden input
      if (!data && button.id && button.id.includes("selected-value")) {
        const popoverId = button.id.replace("-selected-value", "");
        const popover = document.getElementById(popoverId);
        if (popover) {
          const hiddenInput = popover.querySelector("input[type='hidden']");
          if (hiddenInput) {
            data = hiddenInput.value;
          }
        }
      }
      if (data && data.includes("/")) {
        const currentMeasurement = data.split("/")[measurement == 0 ? 0 : 1];
        // Update text content
        if (button.tagName === "SPAN") {
          button.textContent = currentMeasurement;
        } else {
          // For buttons, update the span inside or the button text
          const span = button.querySelector("span");
          if (span && !span.classList.contains("variant-picker__dropdown-sold-out-label")) {
            span.textContent = currentMeasurement;
          } else {
            button.innerText = currentMeasurement;
          }
        }
      }
    });
    // const index = document.querySelector(".measurement-selector-index");
    // console.log(index);
    
    // measurement == 0
    //   ? index.classList.remove("measurement-selector-index__move")
    //   : index.classList.add("measurement-selector-index__move");
  };
  handleMeasurementChange(currentMeasurement);

  // Listen for variant changes to update the measurement display
  document.addEventListener("variant:change", function() {
    // Small delay to ensure DOM is updated
    setTimeout(() => {
      handleMeasurementChange(currentMeasurement);
    }, 100);
  });

  // Current frame
  // const currentFrame = document.querySelector("#variant-current-frame");
  // const variantFrames = document.querySelectorAll(".variantFrame div");

  // variantFrames.forEach((variant, i) => {
  //   const frame = variant.getAttribute("data");
  //   variant.addEventListener("click", function () {
      
  //     currentFrame.innerText = frame;
  //   });
  //   if (i > 0) {
  //     variant.addEventListener("click", function (e) {
  //       window.scrollTo({
  //         top: 0,
  //         behavior: "smooth",
  //       });
  //     });
  //   }
  // });

  // // Variant picker
  // const variantButtons = document.querySelector("#variant-current-frame");
  jQuery(".variant-picker_frame label").on("click", function() {
    let frame = jQuery(this).find(" > div").attr("data");
    jQuery("#variant-current-frame").text(frame);
  });
});


